export const urlPathGet = (url: string | null, allowExternal = false) => {
  if (!url) return null;
  if (url.startsWith("/")) return url;

  try {
    const urlObj = new URL(url);
    if (allowExternal || urlObj.hostname === window.location.hostname) {
      return urlObj.pathname;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};
